angular.module('bmsApp.employeeTeam')
	.controller('EmployeeGroupIndexCtrl', EmployeeGroupIndexCtrl);

EmployeeGroupIndexCtrl.$inject = [
	'$scope',
	'$state',
	'$q',
	'ngTableParams',
	'EmployeeGroupSvc',
];

function EmployeeGroupIndexCtrl(
	$scope,
	$state,
	$q,
	ngTableParams,
	EmployeeGroupSvc,
) {
	let self = this;
	let handlers = {};
	self.loading = true;

	let groupParams = {
		page: 1, // show first page
		count: $scope.config.table.params.count, // count per page
		sorting: {
		
		},
		filter: {}
	};


	self.tableParams = new ngTableParams(groupParams, {
		total: 0, // length of data
		counts: $scope.config.table.settings.counts, // available page counts
		getData: function ($defer, params) {
			$scope.updating = true;
			EmployeeGroupSvc.index(params.$params)
				.then(function (response) {
					params.total(response.data.count);
					$defer.resolve(response.data.group_collection);
					self.totalRecords = response.data.count;
					self.loading = false;
				});
		}
	});

	angular.extend(self, {
		loading: null,
		handlers: handlers,
		totalRecords: 0,
	});

	this.$onInit = () => {
		self.loading = true;
	};

	$scope.showEmployees = function(group) {
		EmployeeGroupSvc.showEmployeeModal(group);
	}

	// Handlers --------------------------------------------------------------------------------------------------------
	handlers.rowClicked = (group) => {
		$state.go('main.employee.index.groups.edit', {groupId: group.id});
	};

	$scope.removeGroup = function (group) {
		EmployeeGroupSvc.remove(group.id)
			.then(function (response) {
				if(response.data.success){
					self.tableParams.reload();
				}
			});
	};
}
